﻿<template>
  <nav class="navbar" :class="{ 'is-scrolled': isScrolled }">
    <div class="container">
      <div class="navbar-content">
        <router-link to="/" class="logo">
          <img src="/yinpu-logo.png" alt="茵普科技 Logo" class="logo-image">
          <span class="logo-text">成都茵普科技</span>
        </router-link>

        <div class="nav-menu" :class="{ 'is-open': isMenuOpen }">
          <router-link v-for="item in menuItems" :key="item.path" :to="item.path" class="nav-item"
            :class="{ 'is-active': $route.path === item.path }" @click="isMenuOpen = false">
            {{ item.label }}
          </router-link>
        </div>

        <button class="menu-toggle" @click="isMenuOpen = !isMenuOpen">
          <el-icon :size="24">
            <Menu v-if="!isMenuOpen" />
            <Close v-else />
          </el-icon>
        </button>
      </div>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import { Menu, Close } from '@element-plus/icons-vue'

const isScrolled = ref(false)
const isMenuOpen = ref(false)

const menuItems = [
  { label: '首页', path: '/' },
  { label: '产品展示', path: '/products' },
  { label: '关于我们', path: '/about' },
  { label: '联系我们', path: '/contact' }
]

const handleScroll = () => {
  isScrolled.value = window.scrollY > 50
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped lang="scss">
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: transparent;
  transition: all 0.3s ease;

  &.is-scrolled {
    background: linear-gradient(135deg, #699991 0%, #1385e2 100%);
    backdrop-filter: blur(10px);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

    .logo-image {
      filter: brightness(0) invert(1); /* 保持白色 */
    }

    .logo-text,
    .nav-item {
      color: #fff;
    }
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.navbar-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
}

.logo {
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 8px;

  .logo-image {
    height: 1.5em;
    /* 与文字高度匹配 */
    width: auto;
    max-height: 28px;
    /* 限制最大高度，不超过文字高度 */
    filter: brightness(0) invert(1);
    /* 将logo变为白色 */
    transition: opacity 0.3s;
    vertical-align: middle;
  }

  .logo-text {
    font-size: 24px;
    font-weight: bold;
    color: #fff;
    transition: color 0.3s;
    line-height: 1;
  }
}

.nav-menu {
  display: flex;
  gap: 30px;

  @media (max-width: 768px) {
    position: fixed;
    top: 70px;
    left: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.98);
    flex-direction: column;
    padding: 20px;
    gap: 0;
    transform: translateY(-100%);
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;

    &.is-open {
      transform: translateY(0);
      opacity: 1;
      visibility: visible;
    }
  }
}

.nav-item {
  color: #fff;
  text-decoration: none;
  font-size: 16px;
  padding: 8px 0;
  position: relative;
  transition: color 0.3s;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 2px;
    background: #409eff;
    transition: width 0.3s;
  }

  &:hover,
  &.is-active {
    color: #409eff;

    &::after {
      width: 100%;
    }
  }

  @media (max-width: 768px) {
    color: #333;
    padding: 15px 0;
    border-bottom: 1px solid #eee;
  }
}

.menu-toggle {
  display: none;
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  padding: 8px;

  @media (max-width: 768px) {
    display: block;
  }
}
</style>
